import React from 'react';

import { Outlet, useNavigation } from 'react-router-dom';

import { useAppSelector, useProfile } from '@pkg/hooks';

import { NavigationState } from '@app/routes/types';
import { useAuthTokens } from '@app/store/zustand/auth/useAuthTokens';

export const PublicRoute = ({ ejectAuthenticated = false }: { ejectAuthenticated?: boolean } = {}) => {
    const navigation = useNavigation();
    const { isAuthenticated } = useAuthTokens();
    const { redirectToProfile } = useProfile();

    const isRegisteredUser = useAppSelector((state) => state.user.isRegisteredUser);

    const shouldRedirect =
        isAuthenticated && isRegisteredUser && navigation.state === NavigationState.Idle && ejectAuthenticated;

    if (shouldRedirect) {
        redirectToProfile();
    } else {
        return <Outlet />;
    }
};
